var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkedinGrey(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.512,
    height: 11.95,
    viewBox: "0 0 12.512 11.95",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4593",
    "data-name": "Group 4593",
    transform: "translate(-99.068 -710.05)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4041",
    "data-name": "Path 4041",
    d: "M399.464,292.7v4.423a.2.2,0,0,1-.2.2h-2.283a.2.2,0,0,1-.2-.2V293.01c0-1.082-.387-1.822-1.357-1.822a1.465,1.465,0,0,0-1.374.979,1.826,1.826,0,0,0-.089.653v4.3a.2.2,0,0,1-.2.2h-2.282a.2.2,0,0,1-.2-.2c.005-1.1.028-6.41,0-7.659a.2.2,0,0,1,.2-.2h2.278a.2.2,0,0,1,.2.2v.944c-.005.009-.013.018-.018.027h.018v-.027a2.661,2.661,0,0,1,2.415-1.331c1.762,0,3.084,1.152,3.084,3.626Zm-12.14,4.62h2.283a.2.2,0,0,0,.2-.2v-7.661a.2.2,0,0,0-.2-.2h-2.283a.2.2,0,0,0-.2.2v7.661A.2.2,0,0,0,387.324,297.321Z",
    transform: "translate(-287.883 424.679)",
    fill: "rgba(51,51,51,0.4)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_49",
    "data-name": "Ellipse 49",
    cx: 1.434,
    cy: 1.434,
    r: 1.434,
    transform: "translate(99.068 710.05)",
    fill: "rgba(51,51,51,0.4)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinGrey);
export default __webpack_public_path__ + "static/media/linkedin-grey.863b88a0c7d07e07b05fefb47b1a98a3.svg";
export { ForwardRef as ReactComponent };